import React, { useEffect, useState } from 'react';

import { Container, Typography } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import PatientList from '../../components/patientList/PatientList';
import ReinvitePatient from '../../components/reinvitePatient/ReinvitePatient';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const [patients, setPatients] = useState([]);
  const [total, setTotal] = useState(0);
  const [isMediphanyWorkspace, setIsMediphanyWorkspace] = useState(false);
  const [currentUser, setCurrentUser] = useState();
  const blocRef = useBlocRef('patientListBloc');

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    new LogService().create({
      action: ACTIONS.PATIENTS_VIEWED,
      details: {
        Amount: 10,
        Page: 1,
      },
    });
  }, []);

  useEffect(() => {
    const patientsSub = blocRef.current.patients$.subscribe(setPatients);
    const totalSub = blocRef.current.total$.subscribe(setTotal);
    const isMediphanyWorkspaceSub = blocRef.current.isMediphanyWorkspace$.subscribe(setIsMediphanyWorkspace);
    const currentUserSub = blocRef.current.currentUser$.subscribe(setCurrentUser);

    return () => {
      patientsSub.unsubscribe();
      totalSub.unsubscribe();
      isMediphanyWorkspaceSub.unsubscribe();
      currentUserSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCriteriaChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria(updatedCriteria);

    new LogService().create({
      action: ACTIONS.PATIENTS_VIEWED,
      details: {
        Amount: updatedCriteria?.limit || 10,
        Page: updatedCriteria?.page + 1,
      },
    });
  };

  const handleInvitePatient = (patient) => {
    blocRef.current.resendInvite(() => <ReinvitePatient patient={patient} workspaceId={blocRef.current.getWorkspaceId()} />);
  };

  const deleteMessage = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <div style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this patient?</div>
      <br />
      <div>All the cases, images or studies related to this patient will be deleted. Only logs of its existence will prevale</div>
      <br />
      <div style={{ color: 'red' }}>This action can not be undone.</div>
    </div>
  );

  const toastSuccess = () => {
    enqueueSnackbar('Patient deleted successfully', { autoHideDuration: 5000, variant: 'success' });
  };

  const refreshData = async () => {
    await blocRef.current.getPatients();
  };

  const handleDeletePatient = async (patientId) => {
    await blocRef.current.deleteUser(patientId, deleteMessage, refreshData, toastSuccess);
  };

  return (
    <Container style={{ padding: '50px 200px' }} maxWidth="100%">
      <Typography variant="h4" className="page-header mb-1" align="left">
        Patients
      </Typography>

      <Typography variant="body1" className="body-copy mb-1" align="left">
        {isMediphanyWorkspace ? 'View the list of all patients.' : 'View a list of current patients that you have invited. You can also reinvite patients if required.'}
      </Typography>

      <PatientList
        currentUser={currentUser}
        isMediphanyWorkspace={isMediphanyWorkspace}
        onCriteriaChange={handleCriteriaChange}
        onInvitedClick={handleInvitePatient}
        patients={patients}
        total={total}
        onUserDelete={handleDeletePatient}
      />
    </Container>
  );
};
